import { render } from "./NewsEditGallery.vue?vue&type=template&id=16b93a53&scoped=true"
import script from "./NewsEditGallery.vue?vue&type=script&lang=js"
export * from "./NewsEditGallery.vue?vue&type=script&lang=js"

import "./NewsEditGallery.vue?vue&type=style&index=0&id=16b93a53&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b93a53"]])

export default __exports__